import type { FindPackageByIdData } from "@/app/lib/types/codegen";
import { Image } from "@/app/ui/Image";

type Props = {
  trip: FindPackageByIdData;
};

export function OverviewCard({ trip }: Props) {
  return (
    <div className="rounded-3xl bg-white p-1">
      <Image
        src={trip.imageUrls[0]}
        alt={trip.name}
        className="aspect-7/2 w-full rounded-t-2xl object-cover"
      />

      <div className="p-3">
        <div className="mb-1 text-xl font-medium text-text-title">
          {trip.name}
        </div>
        <div className="text-sm text-text-tertiary">{trip.subtitle}</div>
      </div>
    </div>
  );
}
